import React from 'react'

const Services = () => {

    return(
        <div className = "services">
            <h1 className = "section-header">Services</h1>

            <h2 className = "service-h2">Residential</h2>

            <p>Our residential work charges $50 per hour. This will include:</p>

            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquam libero praesentium, in consectetur esse fugit eaque illo non recusandae blanditiis quos! Deleniti, ipsam minima. Magni fugit dolorem aliquam maiores cum!</p>

            <h2 className = "service-h2">Commercial Work</h2>

            <p>Our commercial work charges $80 per hour. This will include:</p>

            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquam libero praesentium, in consectetur esse fugit eaque illo non recusandae blanditiis quos! Deleniti, ipsam minima. Magni fugit dolorem aliquam maiores cum!</p>

            <h2 className = "service-h2">New Installations</h2>

            <p>Our new installations work charges $125 per hour. This will include:</p>

            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquam libero praesentium, in consectetur esse fugit eaque illo non recusandae blanditiis quos! Deleniti, ipsam minima. Magni fugit dolorem aliquam maiores cum!</p>

        </div>        
    )
}

export default Services